import React from "react";
import { connect } from 'react-redux';

class MDSubBanner extends React.Component {
    render() {
        const { SubBannerTitle } = this.props;
        console.log("path", window.location.pathname);
        return (
            <div>
                {SubBannerTitle !== "" ? (
                    <>
                        {
                            window.location.pathname == "/Home/MMPlDashboard" || window.location.pathname == "/Home/MMPLDashboard" || window.location.pathname.includes("/Home/MMPLDashboardClient/") ?
                              null : <div className="sub-banner sub-banner-height" style={{ width: "100%" }}>
                                 <div className="row w-100">
                                     <div className="col-sm-12">
                                         <ul id="nav">
                                             <li className="ml-2">
                                                 <div className="page-head">
                                                     <h2 className = {SubBannerTitle == "SDoC LIBRARY"? "sub-banner-title ml-2":"ml-2"}>{SubBannerTitle}</h2>
                                                 </div>
                                             </li>
                                         </ul>
                                     </div>
                                 </div>
                             </div>
                        }
                    </>
                ) : null}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        SubBannerTitle: state.SidePanReducer.SubBannerTitle || "Dashboard"
    }
}

export default connect(mapStateToProps, null)(MDSubBanner);